import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { Layout, Menu, Icon } from 'antd'
import ShowModal from '../ShowModal'
import { FormattedMessage } from 'react-intl'
import listMenu from './menus/lists'
import adminMenu from './menus/admin'
import letterMenu from './menus/letter'
import _ from 'lodash'

const { SubMenu } = Menu
const { Sider } = Layout

const SideBar = (props) => {
    return (
        <Sider
            width={250}
            collapsed={props.collapsed}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: props.collapsed ? 'column' : 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: 24,
                    color: '#fff',
                    padding: '10px 0',
                    backgroundColor: '#003363',
                }}
            >
                <b>G-TMS</b>
            </div>
            <div style={{ height: 'calc(100vh - 56px)', overflowY: 'auto' }}>
                <Menu
                    mode="inline"
                    theme="dark"
                    selectedKeys={[`/model/${props.location.pathname.split('/')[2]}`]}
                    style={{ height: '100%', borderRight: 0 }}
                >
                    {
                        Boolean(_.find(props.permissions, p => p.name === 'Crear')) &&
                        <Menu.Item>
                            <ShowModal type="form" model="dispatch">
                                <div>
                                    <Icon type="plus" />
                                    <span><FormattedMessage id={'Sidebar.newDispatch'} /></span>
                                </div>
                            </ShowModal>
                        </Menu.Item>
                    }
                    <Menu.Item key={'/model/dispatch'}>
                        <Link to={'/model/dispatch'}>
                            <Icon type={'rocket'} />
                            <span><FormattedMessage id={'Model.dispatch.list'} /></span>
                        </Link>
                    </Menu.Item>
                    <Menu.Item key={'/model/exchange'}>
                        <Link to={'/model/exchange'}>
                            <Icon type={'dollar'} />
                            <span><FormattedMessage id={'Model.exchange.list'} /></span>
                        </Link>
                    </Menu.Item>
                    {
                        Boolean(_.find(props.permissions, p => p.name === 'Catálogos')) &&
                        letterMenu.map((item) => {

                            if (item.hasOwnProperty('childrens')) {
                                return (
                                    <SubMenu key='letter' title={<span><Icon type={item.icon} /><span>{item.title}</span></span>}>
                                        {item.childrens.map((_item, _index) => <Menu.Item key={_item.path}><Link to={_item.path}>{_item.title}</Link></Menu.Item>)}
                                    </SubMenu>
                                )
                            }


                            return (
                                <Menu.Item key={item.path}>
                                    <Link to={item.path}>
                                        <Icon type={item.icon} />
                                        <span>{item.title}</span>
                                    </Link>
                                </Menu.Item>
                            )
                        })
                    }
                    {
                        Boolean(_.find(props.permissions, p => p.name === 'Catálogos')) &&
                        listMenu.map((item) => {
                            if (item.hasOwnProperty('childrens')) {
                                return (
                                    <SubMenu key={item.title} title={<span><Icon type={item.icon} /><span>{item.title}</span></span>}>
                                        {item.childrens.map((_item, _index) => <Menu.Item key={_item.path}><Link to={_item.path}>{_item.title}</Link></Menu.Item>)}
                                    </SubMenu>
                                )
                            }

                            return (
                                <Menu.Item key={item.path}>
                                    <Link to={item.path}>
                                        <Icon type={item.icon} />
                                        <span>{item.title}</span>
                                    </Link>
                                </Menu.Item>
                            )
                        })
                    }
                    {
                        Boolean(_.find(props.permissions, p => p.name === 'Perfiles')) &&
                        adminMenu.map((item) => {
                            if (item.hasOwnProperty('childrens')) {
                                return (
                                    <SubMenu key={item.title} title={<span><Icon type={item.icon} /><span>{item.title}</span></span>}>
                                        {item.childrens.map((_item, _index) => <Menu.Item key={_item.path}><Link to={_item.path}>{_item.title}</Link></Menu.Item>)}
                                    </SubMenu>
                                )
                            }

                            return (
                                <Menu.Item key={item.path}>
                                    <Link to={item.path}>
                                        <Icon type={item.icon} />
                                        <span>{item.title}</span>
                                    </Link>
                                </Menu.Item>
                            )
                        })
                    }
                </Menu>
            </div>
        </Sider>
    )
}

const mapStateToProps = state => ({
    permissions: state.auth.permissions,
    collapsed: state.settings.sideBarCollapsed
})

export default withRouter(connect(mapStateToProps)(SideBar))



// WEBPACK FOOTER //
// ./src/containers/SideBar/index.js